import React from 'react'
import Form from '../../components/Form'
import fields, { ChangeEmailFormData } from './fields'
import { handleFormSubmit, useRequest, useAuth } from '@polvo-labs/react-auth'
import { toast } from 'react-toastify'

interface Props {
  onSubmit: () => void
}

const ChangeEmailForm: React.FC<Props> = ({ onSubmit }) => {
  const { user } = useAuth()
  const { request } = useRequest()

  return (
    <Form<ChangeEmailFormData>
      buttonLabel="ENVIAR"
      fields={fields}
      onSubmit={data => handleFormSubmit({
        request: request({
          method: 'PUT',
          url: `${process.env.REACT_APP_API_URL}/users/${user.id}`,
          data,
        }),
        onValidationErrors: () => toast.error('Erros de validacao.'),
        onSuccess: () => {
          toast.success('Seus dados foram atualizados com sucesso.')
          onSubmit()
        },
        onFailure: () => toast.error('Erro ao alterar informações.'),
      })}
    />
  )
}

export default ChangeEmailForm
